export const menuInstituicao: any = [
  {
    id: 'agenda-menu',
    name: 'Agenda',
    icon: 'event',
    page: 'organization-new/calendario',
  },
  {
    id: 'agendados-menu',
    name: 'Agendados',
    icon: 'schedule',
    page: 'organization-new/agendados',
  },
  {
    id: 'patients-menu',
    name: 'Pacientes',
    icon: 'groups',
    page: 'organization-new/pacientes',
  },
  {
    id: 'practitioner-menu',
    name: 'Especialistas',
    icon: 'perm_identity',
    page: 'organization-new/especialistas',
  },
  {
    id: 'users-menu',
    name: 'Sub-Usuários',
    icon: 'supervised_user_circle',
    page: 'organization-new/usuarios',
  },
  {
    id: 'servico-menu',
    name: 'Exames',
    icon: 'medical_information',
    page: 'organization-new/exames',
  },
  {
    id: 'perfil-menu',
    name: 'Faturamento',
    icon: 'request_quote',
    page: 'organization-new/faturamento',
  },
  {
    id: 'bank-account-menu',
    name: 'Dados Bancários',
    icon: 'account_balance',
    page: 'organization-new/dados-bancarios',
  },
  {
    id: 'perfil-menu',
    name: 'Meus dados',
    icon: 'manage_accounts',
    page: 'organization-new/meus-dados',
  },
];

export const menuPatient: any = [
  {
    id: 'consulta-menu',
    name: 'Agendar',
    icon: 'event',
    page: 'patient-new/agendar',
  },
  {
    id: 'consulta-menu',
    name: 'Agendados',
    icon: 'schedule',
    page: 'patient-new/agenda/status',
  },
  {
    id: 'perfil-menu',
    name: 'Meus dados',
    icon: 'manage_accounts',
    page: 'patient-new/meus-dados',
  },
];

export const menuSecretary: any = [
  {
    id: 'consulta-menu',
    name: 'Agendar',
    icon: 'event',
    page: 'secretarias-new/agendar',
  },
  {
    id: 'consulta-menu',
    name: 'Agendados',
    icon: 'schedule',
    page: 'secretarias-new/agenda/status',
  },
  {
    id: 'perfil-menu',
    name: 'Faturamento',
    icon: 'request_quote',
    page: 'secretarias-new/faturamento',
  },
  {
    id: 'perfil-menu',
    name: 'Dados Bancarios',
    icon: 'request_quote',
    page: 'secretarias-new/account',
  },
  {
    id: 'perfil-menu',
    name: 'Meus dados',
    icon: 'manage_accounts',
    page: 'secretarias-new/meus-dados',
  },
];

export const menuPractitioner: any = [
  {
    id: 'home-menu',
    name: 'Início',
    icon: 'dashboard',
    page: 'medico/dashboard',
  },
  {
    id: 'agenda-menu',
    name: 'Agenda',
    icon: 'event',
    page: 'medico/agenda',
  },
  {
    id: 'patient-menu',
    name: 'Pacientes',
    icon: 'groups',
    page: 'medico/pacientes',
  },
  {
    id: 'organization-menu',
    name: 'Locais de Trabalho',
    icon: 'apartment',
    page: 'medico/instituicoes',
  },
  {
    id: 'perfil-menu',
    name: 'Meus dados',
    icon: 'manage_accounts',
    page: 'medico/meus-dados',
  },
];
